var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1LeftRightArrowD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 19.77L44.81 17 66 38 44.81 59 42 56.23 60.41 38 42 19.77zM15.61 38L34 19.77 31.21 17 10 38l21.2 21 2.8-2.77L15.61 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Left-right_arrow_D.1b9e2edb.svg";
export { SvgJ1LeftRightArrowD as ReactComponent };